var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect, _rect2, _rect3, _rect4, _path32, _path33, _path34, _path35, _rect5, _rect6, _rect7, _rect8, _path36, _path37, _path38, _path39, _rect9, _rect10, _rect11, _rect12, _path40, _path41, _path42, _path43, _rect13, _rect14, _rect15, _rect16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecursoNuevoMvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#b6dcef;}.cls-3{fill:#434341;}.cls-4{fill:#4ab3e5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.13,141.15h6.21l14.35,15v-15H516v31.49h-6.52l-14.09-15v15h-9.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.81,141.15h9.5v18a5.73,5.73,0,0,0,1.37,4,4.68,4.68,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V160a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67a14.93,14.93,0,0,1-10.48-3.67,12.48,12.48,0,0,1-4-9.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.6,141.15h24.3v8H566.09v3.74h12.74v7.74H566.09v4h15.26v8H556.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M584.81,141.15h10.35l6.93,19.21,6.8-19.21h10.35l-12.92,31.49h-8.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625,145.06a17.16,17.16,0,0,1,23.45,0,17.55,17.55,0,0,1,0,23.67,17.13,17.13,0,0,1-23.45,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.26,6.26,0,0,0,4.91-2.18,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454,195.15h15.26a13,13,0,0,1,8.71,2.83,9.71,9.71,0,0,1-.88,15.35,6.94,6.94,0,0,1,2.56,3l3.83,10.26h-9.72l-3.29-8.9a2,2,0,0,0-2-1.27h-4.95v10.17H454Zm9.5,8v5.4h5.67a2.52,2.52,0,0,0,1.93-.76,3,3,0,0,0,0-3.9,2.58,2.58,0,0,0-1.93-.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.52,195.15h24.3v8H497v3.74h12.73v7.74H497v4h15.25v8H487.52Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.55,208.42a7.2,7.2,0,0,0,.23-1.75,3,3,0,0,0-1.53-2.5,7.77,7.77,0,0,0-9.23,1.17,8.92,8.92,0,0,0,0,11.16,6.7,6.7,0,0,0,5.22,2.13,6,6,0,0,0,4.16-1.37,5.32,5.32,0,0,0,1.78-3.62h9a14.36,14.36,0,0,1-4.95,9.86,15.84,15.84,0,0,1-10.8,3.87A15.09,15.09,0,0,1,521,222.75a17.81,17.81,0,0,1,.2-23.69q4.62-4.63,12.08-4.63a16.36,16.36,0,0,1,10.4,3.21,10,10,0,0,1,4.09,8.22,6.49,6.49,0,0,1-.49,2.56Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553,195.15h9.5v18a5.73,5.73,0,0,0,1.37,4,4.68,4.68,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V214a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67A14.93,14.93,0,0,1,557,223.7a12.48,12.48,0,0,1-4-9.66Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.74,195.15H603A13,13,0,0,1,611.7,198a9.71,9.71,0,0,1-.88,15.35,7,7,0,0,1,2.57,3l3.82,10.26h-9.72l-3.28-8.9a2,2,0,0,0-2-1.27h-4.95v10.17h-9.49Zm9.49,8v5.4h5.67a2.54,2.54,0,0,0,1.94-.76,3,3,0,0,0,0-3.9,2.6,2.6,0,0,0-1.94-.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.72,215.35a2,2,0,0,0-.27,1q0,2.75,5.4,2.75c3.09,0,4.64-.45,4.64-1.35s-2.12-1.82-6.35-2.39c-4.59-.71-7.83-1.88-9.72-3.48a8.15,8.15,0,0,1-2.83-6.55,9.8,9.8,0,0,1,3.58-8q3.57-3,9.74-3a16.19,16.19,0,0,1,9.69,2.7,8.19,8.19,0,0,1,3.76,6.93,5,5,0,0,1-.54,2.34h-9a2.55,2.55,0,0,0,.27-1q0-2.66-4.5-2.65c-2.55,0-3.82.48-3.82,1.44s2.13,1.83,6.39,2.34q6.66.81,9.58,3.3a8.51,8.51,0,0,1,2.93,6.82,9.33,9.33,0,0,1-3.81,7.87q-3.79,2.88-10.28,2.89a18.41,18.41,0,0,1-10.37-2.68c-2.69-1.79-4-4.07-4-6.86a5.49,5.49,0,0,1,.59-2.48Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.22,199.06a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67ZM664,216.45a6.59,6.59,0,0,0,9.79,0,9,9,0,0,0,0-11.11,6.59,6.59,0,0,0-9.79,0,9,9,0,0,0,0,11.11Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "253.16 188.97 277.05 188.97 275.32 166.35 254.53 166.3 253.16 188.97"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.91,190.69H251.32l1.59-26.12,24,.07ZM255,187.24h20.2l-1.46-19.17-17.58,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.34,157.32,170,197.81c-6.47,15.65,3.22,58.37,22.46,61.91l16.9,3.11c17.9,3.3,40.58-17.31,42.9-32.74l4.62-58.54c2.15-14.34-9.2-28-25.84-31.06C215.62,137.67,200.5,144.8,195.34,157.32Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.26,264.91a24,24,0,0,1-4.27-.38l-16.89-3.11c-6.43-1.19-12.31-6.38-17-15-8.19-15.07-11.34-38.08-6.72-49.25l.13-.26,25.31-40.37c5.55-13.25,21.29-20.69,37.5-17.72,17.54,3.23,29.49,17.7,27.24,32.94l-4.63,58.6c-1.33,8.87-8.79,19.31-19,26.61C227.6,262.16,220.07,264.9,213.26,264.91ZM171.49,198.6c-4.13,10.23-1,32.16,6.62,46.15,2.92,5.37,7.83,12,14.61,13.28l16.9,3.11c6.91,1.27,15.18-1.22,23.28-7,9.32-6.65,16.39-16.39,17.59-24.25l4.63-58.6c2-13.42-8.72-26.2-24.44-29.1-14.68-2.7-28.87,3.94-33.75,15.78l-.13.26Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.49,157.36l25.38,40.49c6.48,15.65-3.21,58.37-22.46,61.92l-16.87,3.1c-17.91,3.3-40.58-17.3-42.9-32.74L271,171.59c-2.16-14.34,9.2-28,25.83-31.05C312.19,137.72,327.31,144.84,332.49,157.36Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.59,265c-6.81,0-14.34-2.75-21.64-8-10.22-7.29-17.68-17.73-19-26.6v-.12l-4.65-58.48C267,156.54,279,142.08,296.5,138.84c16.21-3,32,4.48,37.52,17.72l25.45,40.63c4.61,11.17,1.47,34.18-6.73,49.24-4.7,8.65-10.59,13.85-17,15l-16.87,3.11A23.85,23.85,0,0,1,314.59,265Zm-37.24-35c1.21,7.86,8.27,17.6,17.6,24.25,8.1,5.79,16.37,8.27,23.28,7l16.87-3.11c6.79-1.25,11.69-7.91,14.62-13.28,7.61-14,10.74-35.92,6.62-46.15L330.89,158c-4.89-11.83-19.09-18.48-33.76-15.78-15.73,2.9-26.46,15.69-24.45,29.11l0,.12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.78,269.73a48.63,48.63,0,1,0-48.5-48.63A48.57,48.57,0,0,0,320.78,269.73Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.78,271.46A50.36,50.36,0,1,1,371,221.1,50.35,50.35,0,0,1,320.78,271.46Zm0-97.26a46.91,46.91,0,1,0,46.77,46.9A46.9,46.9,0,0,0,320.78,174.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.78,253.33a32.23,32.23,0,1,0-32.14-32.22A32.18,32.18,0,0,0,320.78,253.33Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.78,255.06a34,34,0,1,1,33.86-33.95A34,34,0,0,1,320.78,255.06Zm0-64.46a30.51,30.51,0,1,0,30.42,30.51A30.5,30.5,0,0,0,320.78,190.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.73,269.73a48.63,48.63,0,1,0-48.49-48.63A48.56,48.56,0,0,0,208.73,269.73Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.73,271.46A50.36,50.36,0,1,1,259,221.1,50.35,50.35,0,0,1,208.73,271.46Zm0-97.26a46.91,46.91,0,1,0,46.78,46.9A46.89,46.89,0,0,0,208.73,174.2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.74,253.33a32.23,32.23,0,1,0-32.15-32.22A32.18,32.18,0,0,0,208.74,253.33Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.74,255.06a34,34,0,1,1,33.86-33.95A33.95,33.95,0,0,1,208.74,255.06Zm0-64.46a30.51,30.51,0,1,0,30.41,30.51A30.5,30.5,0,0,0,208.74,190.6Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196,82.88c-.81,4.86-1.5,9.74-2.43,14.57-3.41,17.55-13.08,31.15-26.71,42.29-8.66,7.08-17.13,14.38-25.77,21.48a4.75,4.75,0,0,0-2,4.17q.15,9.35,0,18.7a3.84,3.84,0,0,1-1.1,2.77c-4.55,3.22-9.23,6.25-14.16,9.54-1.47-5.34-2.87-10.43-4.26-15.52-.76-2.79-1.92-3.61-4.24-2.07-5,3.3-9,1.73-12.61-2.08-2.9-3-5.69-6.19-8.4-9.4a4.64,4.64,0,0,1-.52-5.85,16.12,16.12,0,0,0,1.27-2.73c.88-2.29.08-3.83-2.3-4.49-5-1.39-10-2.75-15.29-4.21,3.33-5,6.42-9.73,9.67-14.35a3.65,3.65,0,0,1,2.6-.92c6.05-.07,12.1-.11,18.15,0a4.83,4.83,0,0,0,4.14-2c9-10.49,18-21,27.21-31.34,11-12.38,25.37-18.59,41.26-21.79,3.47-.7,7-1.14,10.49-1.7h5Zm-36,20.85a10.33,10.33,0,0,0-10.49,10.14A10.5,10.5,0,0,0,160,124.43a10.34,10.34,0,0,0,10.27-10.36A10.16,10.16,0,0,0,160,103.73Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.21,194c.56-2.84,1-5.71,1.7-8.53,1.88-7.75,5.29-14.58,12-19.48,1.69,1.25,1.45,2.41.39,4.07-4.39,6.87-5.59,14.54-5.41,22.9,8.29.3,16-1,23-5.32,2-1.22,2-1.24,4.1.21-4.82,6.83-11.72,10.25-19.54,12.16-2.82.69-5.69,1.14-8.53,1.7H72.21Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.77,266.63A1,1,0,0,1,422,265l7.95-10.82a1,1,0,1,1,1.63,1.2l-7.94,10.82A1,1,0,0,1,422.77,266.63Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.52,287.4a1,1,0,0,1-.59-.2,1,1,0,0,1-.22-1.41L414.65,275a1,1,0,1,1,1.64,1.2l-8,10.82A1,1,0,0,1,407.52,287.4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M414.43,268.13a1,1,0,0,1-.6-.2L403,260a1,1,0,0,1-.22-1.42,1,1,0,0,1,1.42-.21L415,266.3a1,1,0,0,1-.6,1.83Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M435.2,283.37a1,1,0,0,1-.59-.19l-10.83-7.95a1,1,0,0,1-.22-1.41,1,1,0,0,1,1.42-.22l10.82,7.94a1,1,0,0,1-.6,1.83Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 415.84,
    y: 251.41,
    width: 2.03,
    height: 10.16,
    transform: "translate(-34.07 66.18) rotate(-8.72)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 420.25,
    y: 280.11,
    width: 2.03,
    height: 10.16,
    transform: "translate(-38.37 67.18) rotate(-8.72)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 399.96,
    y: 271.95,
    width: 10.16,
    height: 2.03,
    transform: "translate(-36.76 64.68) rotate(-8.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 428.66,
    y: 267.55,
    width: 10.16,
    height: 2.03,
    transform: "translate(-35.76 68.99) rotate(-8.74)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.82,63.91a1,1,0,0,1-1-1l-.35-23.22a1,1,0,0,1,2,0l.35,23.22a1,1,0,0,1-1,1Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.49,108.45a1,1,0,0,1-1-1l-.35-23.21a1,1,0,0,1,1-1,1,1,0,0,1,1,1l.35,23.21a1,1,0,0,1-1,1Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.68,75a1,1,0,0,1-1-1,1,1,0,0,1,1-1l23.21-.35a1,1,0,1,1,0,2L64.7,75Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.23,74.36a1,1,0,0,1,0-2L132.42,72a1,1,0,0,1,1,1,1,1,0,0,1-1,1l-23.22.35Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.13,
    y: 47.71,
    width: 2.03,
    height: 17.57,
    transform: "translate(-16.21 74.67) rotate(-45.86)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.15,
    y: 82.66,
    width: 2.03,
    height: 17.57,
    transform: "translate(-30.36 111.14) rotate(-45.86)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.27,
    y: 90.52,
    width: 17.57,
    height: 2.03,
    transform: "translate(-41.08 85.98) rotate(-45.87)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.22,
    y: 54.49,
    width: 17.57,
    height: 2.03,
    transform: "translate(-4.61 100.13) rotate(-45.87)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.3,83.87a1.42,1.42,0,0,1-1.42-1.39L398.4,50.1a1.4,1.4,0,0,1,1.39-1.43,1.42,1.42,0,0,1,1.43,1.39l.49,32.38a1.41,1.41,0,0,1-1.39,1.43Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.23,146a1.41,1.41,0,0,1-1.41-1.39l-.49-32.38a1.41,1.41,0,0,1,1.39-1.43,1.38,1.38,0,0,1,1.44,1.39l.49,32.38a1.42,1.42,0,0,1-1.4,1.43Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.08,99.39a1.42,1.42,0,0,1,0-2.83l32.38-.49a1.42,1.42,0,0,1,0,2.83l-32.38.49Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M416.21,98.45a1.42,1.42,0,0,1,0-2.83l32.38-.48A1.46,1.46,0,0,1,450,96.53,1.41,1.41,0,0,1,448.61,98l-32.38.49Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 374.23,
    y: 61.28,
    width: 2.83,
    height: 24.5,
    transform: "translate(61.28 291.91) rotate(-45.86)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 424.48,
    y: 110.03,
    width: 2.83,
    height: 24.51,
    transform: "translate(41.55 342.78) rotate(-45.86)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 364.66,
    y: 120.99,
    width: 24.5,
    height: 2.83,
    transform: "translate(26.62 307.71) rotate(-45.87)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 413.42,
    y: 70.74,
    width: 24.5,
    height: 2.83,
    transform: "translate(77.49 327.45) rotate(-45.87)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.43,287.18a1,1,0,0,1-.82-1.61l8-10.82a1,1,0,0,1,1.41-.22,1,1,0,0,1,.22,1.42l-7.94,10.82A1,1,0,0,1,100.43,287.18Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.18,308a1.05,1.05,0,0,1-.6-.2,1,1,0,0,1-.21-1.42l7.94-10.82a1,1,0,0,1,1.64,1.2l-8,10.82A1,1,0,0,1,85.18,308Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.09,288.69a1,1,0,0,1-.6-.2l-10.82-7.94a1,1,0,0,1,1.2-1.64l10.82,7.95a1,1,0,0,1,.22,1.41A1,1,0,0,1,92.09,288.69Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.86,303.93a1,1,0,0,1-.6-.19l-10.82-7.95a1,1,0,1,1,1.2-1.63l10.82,7.94a1,1,0,0,1-.6,1.83Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.5,
    y: 271.97,
    width: 2.03,
    height: 10.16,
    transform: "translate(-40.93 17.54) rotate(-8.72)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.91,
    y: 300.66,
    width: 2.03,
    height: 10.16,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -45.22, 18.54)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.62,
    y: 292.51,
    width: 10.16,
    height: 2.03,
    transform: "translate(-43.55 15.93) rotate(-8.72)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.31,
    y: 288.11,
    width: 10.16,
    height: 2.03,
    transform: "translate(-42.55 20.23) rotate(-8.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursoNuevoMvl);
export default __webpack_public_path__ + "static/media/Recurso_nuevo-mvl.4bb6f5f53143e315c651430d666defa3.svg";
export { ForwardRef as ReactComponent };